import React from 'react'
import { connect } from 'react-redux'
import VwnRecommendationsContainer from './recommendationsContainer'
import AiRecommendationsContainer from '../ai-recommendations-component/aiRecommendationsContainer'
import isAirecEnabledSelector from '../../redux/selectors/feature-scope/isAirecEnabledSelector'
import { State } from '../../redux/reducers/rootReducer'

type Props = {
    isAirecEnabled: boolean
}

const RecommendationsContainerWrapper: React.FC<Props> = ({ isAirecEnabled }) => {
    if (isAirecEnabled) {
        return <AiRecommendationsContainer />
    }
    return <VwnRecommendationsContainer />
}

const mapStateToProps = (state: State) => ({
    isAirecEnabled: isAirecEnabledSelector(state),
})

export default connect(mapStateToProps)(RecommendationsContainerWrapper)
